export default __webpack_public_path__ + "static/media/404.16338b63.png";